import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import * as actions from './actions';
import { IUserEntryDate } from '../IUserEntryDates';
import { IUserGroups } from '../IUserGroups';

export interface State {
    groups: Array<IUserGroups>;
    entryDates: Array<IUserEntryDate>;
    errors: Array<string>;
}

export const initialState: State = {
    groups: [],
    entryDates: [],
    errors: []
};

export function reducer(
    state = initialState,
    action: actions.ActionsUnion
): State {
    switch (action.type) {
        case actions.ActionTypes.Reset:
            return initialState;
        case actions.ActionTypes.SetEntryDatesByGroup:
            return {
                ...state,
                entryDates: [...action.payload]
            };
        case actions.ActionTypes.SetGroups:
            return {
                ...state,
                groups: [...action.payload]
            };
        case actions.ActionTypes.SetUserEntryDates:
            return {
                ...state,
                entryDates: [...action.payload]
            };
        case actions.ActionTypes.UpdateUserEntryDatesSuccess:
            const gresp = action.payload;
            return {
                ...state,
                entryDates: state.entryDates
                    .map<IUserEntryDate>(
                        x =>
                            gresp.Items.find(
                                y => y.EmployeeListId === x.EmployeeListId
                            ) || {
                                ...x
                            }
                    ) // update any existing
                    .concat(
                        gresp.Items.filter(
                            x =>
                                !state.entryDates.find(
                                    y => y.EmployeeListId === x.EmployeeListId
                                )
                        )
                    ), // add any new
                errors: gresp.ErrorMessages
            };
        default:
            return state;
    }
}
const StateFeatureSelector = createFeatureSelector<State>('entrydates');

export const getGroups = createSelector(StateFeatureSelector, x => x.groups);
export const getEntryDates = createSelector(
    StateFeatureSelector,
    x => x.entryDates
);
// export const getEntryDatesByGroup = createSelector(StateFeatureSelector, x => x.entryDates);
export const getEntryDatesErrors = createSelector(
    StateFeatureSelector,
    x => x.errors
);
